import { downloadXlsx } from '../../../components/Downloads/helpers';
import { useCallback } from 'react';

export const useGlobalDownloads = () => {
  const downloadFieldSummaryByCompany = useCallback(async () => {
    const downloadName = 'Welligence - Global Field Summary by Company.xlsx';
    const path = 'global-downloads/export-to-xlsx/';
    const body = {
      downloadType: 'field_summary_by_company',
    };

    const result = await downloadXlsx(path, body, downloadName);

    let errors = [];
    if (!result.ok) {
      const json = await result.json();
      errors = json?.errors || [];
    }

    return { ok: result.ok, status: result.status, errors };
  }, []);

  return { downloadFieldSummaryByCompany };
};
